import { useController } from 'react-hook-form';
import Select from '@alfa-retail-react/components/select';
import React, { useEffect } from 'react';
import { useFormContext } from '@alfa-retail-react/components';
import { observer } from 'mobx-react';

import { WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { useIsDesktop } from 'app/utils/useWindowType';
import { EmploymentFormStore } from 'app/logic/pages/employment/EmploymentFormStore';
import { EmploymentFormValues } from 'app/logic/pages/employment/EmploymentPage';
import { ValidationRules } from 'app/form/ValidationRules';

export interface ActivityFieldCodeFormItemProps {
    formStore: EmploymentFormStore;
}

const ACTIVITY_FIELD_CODE_FORM_ITEM_NAME = 'activityFieldCode';
const ACTIVITY_FIELD_CODE_FIELD_LABEL = 'Сфера деятельности компании';

export const ActivityFieldCodeFormItem = observer(
    ({ formStore }: ActivityFieldCodeFormItemProps) => {
        const {
            control,
            setValue,
            trigger,
            handleMultipleErrors,
            setFieldElement,
        } = useFormContext<EmploymentFormValues>();
        const [isDesktop] = useIsDesktop();

        const { field, fieldState } = useController<EmploymentFormValues>({
            name: ACTIVITY_FIELD_CODE_FORM_ITEM_NAME,
            control,
            defaultValue: formStore.activityFieldCode ?? '',
            rules: {
                required: ValidationRules.required(),
            },
        });

        // Вызывается при изменении поля извне, к примеру после изменения вида деятельности
        useEffect(() => {
            setValue(
                ACTIVITY_FIELD_CODE_FORM_ITEM_NAME,
                formStore.activityFieldCode,
            );

            if (formStore.isAttorney) {
                trigger(ACTIVITY_FIELD_CODE_FORM_ITEM_NAME);
            }
        }, [formStore.activityFieldCode]);

        return (
            <Select
                className={WEB_VISOR_HIDE}
                componentRef={(element) => {
                    field.ref(element);
                    setFieldElement(
                        ACTIVITY_FIELD_CODE_FORM_ITEM_NAME,
                        element,
                    );
                }}
                isDesktop={isDesktop}
                size="l"
                disabled={formStore.isAttorney}
                options={formStore.industriesReference}
                selected={String(field.value)}
                error={handleMultipleErrors(fieldState.error)}
                label={ACTIVITY_FIELD_CODE_FIELD_LABEL}
                onBlur={field.onBlur}
                onChange={(event) => {
                    field.onChange(event.selected.key);
                    formStore.setActivityFieldCode(event.selected.key);
                }}
            />
        );
    },
);
